import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PDivider } from '@porsche-design-system/components-react';

export const Divider = styled(
  PDivider,
  {
    base: {
      marginTop: 'md',
      marginBottom: 'md',
    },
  },
  { forwardProps: ['direction'] },
);
